<template>
  <v-row>
    <v-col
      v-for="(genderOption, index) in genderOptions"
      :key="index"
      class="d-flex justify-center"
    >
      <v-card flat class="text-center" height="100%">
        <v-card-text class="pt-0">
          <component
            :is="componentMap[genderOption]"
            :class="genderOption"
          />
          <div class="text-h6 black--text">
            {{ totalNumber(genderOption) }}
          </div>
          <div class="text-h6">
            {{ averageNumber(genderOption) }}
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import GenderMale from '!!vue-svg-loader!../../../assets/svgs/GenderMale.svg';
import GenderFemale from '!!vue-svg-loader!../../../assets/svgs/GenderFemale.svg';
import { questionVisualisationHelper } from '@/mixins/SuperUtils';

export default {
  components: {
    GenderMale,
    GenderFemale
  },
  mixins: [questionVisualisationHelper],
  props: {
    questionStat: {
      required: true,
      type: Object
    }
  },
  computed: {
    componentMap() {
      return {
        male: 'gender-male',
        female: 'gender-female'
      };
    },
    genderOptions() {
      return Object.keys(this.componentMap);
    }
  },
  methods: {
    averageNumber(gender) {
      return this.formatPercent(
        this.calculateAvgFor(
          gender === 'male'
            ? this.questionStat.numberOfMaleAdults
            : this.questionStat.numberOfFemaleAdults
        )
      );
    },
    totalNumber(gender) {
      return gender === 'male'
        ? this.questionStat.numberOfMaleAdults
        : this.questionStat.numberOfFemaleAdults;
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../scss/main.scss';
svg {
  height: 70px;

  &.male path {
    fill: map-get($grey, 'darken-1');
  }

  &.female path {
    fill: map-get($grey, 'base');
  }
}
</style>
